<template>
  <div class="layout my-talks">
    <div class="tab_content">
      <div class="list_wrap">
        <List v-model="loading" :finished="finished" @load="loadMore"> 
          <!-- 我是客服 -->
            <div class="item" v-for="(item,index) in list" :key="index" @click="LinkChatTalk({userId:item.userId,exhibitorId:item.exhibitorId})" >
               <div class="img_div">
                 <div class="new" v-if="item.unreadNumberToPublisher>0">{{item.unreadNumberToPublisher>99?'99+':item.unreadNumberToPublisher}}</div>
                <img :src="item.member.avatarUrl" v-if="item.member&&item.member.avatarUrl" >
                <span class="flag-icon my-flag-icon logo" v-else-if="item.member.flagStyle" :class="'flag-icon-'+item.member.flagStyle"></span>
                <img v-else src="@/assets/img/empty.png" >
               </div>
              <div class="info">
                <div class="title">
                  <p class="van-ellipsis">{{item.member?(item.member.name||item.member.nickName):''}}</p>
                  <span>{{item.lastDateStr}}</span>
                </div>
                <template v-if="item.lastMessage">
                  <p class="txt van-ellipsis" v-if="item.lastMessage.messageType=='text'">{{item.lastMessage.message.content}}</p>
                  <p class="txt van-ellipsis" v-else-if="item.lastMessage.messageType=='url'">[Video chat room]</p>
                  <p class="txt van-ellipsis" v-else-if="item.lastMessage.messageType=='request'">Apply for video chat</p>
                </template>
                <p class="txt" v-else></p>
              </div>
            </div>
          <div slot="loading" class="f-tac loading">
            <img src="@assets/img/new/icon-loading.png" />
            loading...
          </div>
          <div slot="finished" class="f-tac loading">It's the end~</div>
        </List>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { List } from "vant";
import dateString from '../../../../assets/js/dateString'
export default {
  name: "my-talks",
  components:{
    List,
  },
  data() {
    return {
      loading: false,   //消息列表加载状态
      finished: false,  //消息列表是否完成状态
      list: [],    //消息列表
      pageIndex:0,
      pageSize:20,
      companyUserId:'',
      time:null
    } 
  },
  async created(){
    if(this.$route.params.id){
      this.$store.commit('setExhibitionId',this.$route.params.id);
    }
    if(!this.userInfo){
      await this.$Myapollo.getUserInfo(this);
    }
    this.getCompanyUser()
    // if(!this.exhibitionInfo&&this.exhibitionId){
    //   await this.$Myapollo.getExhibitionInfo(this,this.exhibitionId,this.userInfo.userId);
    // }
    this.init();
  },
  mounted(){
  },
  beforeDestroy(){
    if(this.time){
      clearInterval(this.time);
      this.time=null
    }
  },
  computed: {
    ...mapGetters({
      userInfo:'getUserInfo',
      exhibitionId:"getExhibitionId",
      // exhibitionInfo:"getExhibitionInfo"
    }),
    isServer(){
      let ser=false;
      if(this.userInfo&&this.userInfo.inMember&&this.userInfo.inMember.userRole=='EXHIBITOR'){
        ser=true;
      }
      return ser
    },
  },
  methods:{
    ...mapActions({
      graphqlPost:'en/CNgraphqlPostByZXS',
      LinkChatTalk:'linkTo/LinkChatTalk',
      LinkChatTalkUser:'linkTo/LinkChatTalkUser',
      graphqlPostByToken:'en/graphqlPostByToken'
    }),
    async getCompanyUser(){
      let query=`
        query{
          memberQuery{
            current{
              inMember(exhibitionId:"${this.exhibitionId}"){
                companyUsers{
                  id
                }
              }
            }
          }
        }
      `
      let opt={
        query:query,
        variables:{},
      }
      let data=await this.graphqlPostByToken(opt);
      console.log(data,'datatat')
      let res=JSON.parse(JSON.stringify(data.data.memberQuery.current.inMember.companyUsers));
      if(!res||!res.id){
        this.$toast.fail('Customer service information error');
        // this.loading=false;
        this.finished=true
        return 
      }
      this.companyUserId=res.id;
      this.getList();
    },
    async getList(){
      let query=`
        query($query:QueryInput!){
          agoraQuery{
            query(query:$query){
                hasNextPage
                pageIndex
                totalCount
                items {
                  createAt
                  exhibitorId
                  exhibitor{
                    company{
                      nameEn
                      logo
                    }
                  }
                  member{
                    avatarUrl
                    name
                    nickName
                    flagStyle
                  }
                  id
                  companyUsersId
                  lastMessage{
                    messageType
                    message
                    state
                  }
                  lastMessageAt
                  unreadNumberToPublisher(publisherId:"${this.companyUserId}")
                  userId
                }
              }
            }
        }
      `;
      let where = {
        EqualA_de: {
          n: "isDeleted",
          v: 0,
        },
        EqualB: {
          n: "exhibitionId",
          v: this.exhibitionId,
        },
        EqualC:{
          n: "exhibitorId",
          v:this.userInfo.inMember.exhibitorId
        }
      };
      let order = [
        {
          N: "lastMessageAt",
          v: 0,
        },
      ];
      // where.Equal={
      //   n: "exhibitorId",
      //   v: this.userInfo.inMember.exhibitorId,
      // }
      let opt={
        query:query,
        variables: {
          query: {
            page: this.pageIndex,
            size: this.pageSize,
            where: JSON.stringify(where),
            order: JSON.stringify(order),
          },
        },
      }
      let data = await this.graphqlPost(opt);
      console.log(data,'data')
      let res = JSON.parse(JSON.stringify(data.data.agoraQuery.query));
      res.items.forEach(e => {
        e.lastDateStr=dateString.getDataString(moment(e.lastMessageAt).format('x'),false);
        if(e.lastMessage){
          e.lastMessage.message=JSON.parse(e.lastMessage.message);
        }
      });
      if(this.pageIndex==1){
        this.list=res.items
      }else{
        this.list=[...new Set([...this.list,...res.items])];
      }
      this.loading=false;
      if (!res.hasNextPage) {
        this.finished = true;
      }
      console.log(this.list,'resss询盘');
    },
    init(){
      this.time=setInterval(()=>{
        if(this.list.length){
          this.pageIndex=1;
          this.getList()
        }
      },3000)
    },
    loadMore(){
      if(this.finished||!this.companyUserId) return;
      this.pageIndex+=1;
      this.getList();
    },
    // linkToTalk(item){
    //   let opt={userId:item.userId,exhibitorId:item.exhibitorId}
    //   if(isServer){

    //   }else{

    //   }
    // },
  }
};
</script>

<style lang="scss" scoped>
.my-talks{
  background: #fff;
  .tab_content{
    .list_wrap{
      .item{
        padding: 0.2rem 0 ;
        margin-left:0.3rem ;
        background: #fff;
        border-radius: 0.1rem;
        border-bottom: 1px solid #efefef;
        display: flex;
        align-items: center;
        position: relative;
        .img_div{
          width: 0.88rem;
          height: 0.88rem;
          position: relative;
          margin-right: 0.15rem;
          .new{
            position: absolute;
            right: -0.06rem;
            top: -0.06rem;
            padding: 0.04rem 0.1rem;
            font-size: 12px;
            min-width: 0.28rem;
            height: 0.28rem;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            background: #ff5e00;
            border-radius:0.14rem;
            // line-height: 1;
          }
          img{
            display: block;
            width: 0.88rem;
            height: 0.88rem;
            border-radius: 50%;
            border: 1px solid #f2f2f2;
          }
          .logo{
            display: block;
            width: 0.88rem;
            height: 0.88rem;
            border-radius: 50%;
            border: 1px solid #f2f2f2;
            margin: 0;
            margin-right: 0.15rem;
          }
        }
        .info{
          width: calc(100% - 1.03rem);
          height: 0.88rem;
          .title{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-right: 0.3rem;
            p{
              font-size: 0.3rem;
              color: #333;
            }
            span{
              font-size: 0.22rem;
              color: #999;
            }
          }
          .txt{
            margin-top: 0.13rem;
            color: #999;
            font-size: 0.26rem;
          }
        }
      }
    }
  }
}
.f-tac {
  text-align: center;
}
.loading {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 18px;
    height: 18px;
    display: inline-block;
    margin-right: 5px;
    animation: 1s loader-01 linear infinite;
  }
}
@keyframes loader-01 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
